import ClientService from '../../services/client-service';
import getDealDataQuery from '../../graphql/query/get-deal-data.graphql';
import getDealDataByFileQuery from '../../graphql/query/get-deal-data-by-file.graphql';
import getDealTaskAttachmentTextDataQuery from '../../graphql/query/get-deal-task-attachment-text-data.graphql';
import getDealFileTextDataQuery from '../../graphql/query/get-deal-file-text-data.graphql';
import viewDealFileMutation from '../../graphql/mutation/view-deal-file.graphql';
import saveDealDataMutation from '../../graphql/mutation/save-deal-data.graphql';
import saveDealStatusMutation from '../../graphql/mutation/save-deal-status.graphql';
import saveDealTabSettingsMutation from '../../graphql/mutation/save-deal-tab-settings.graphql';

export default class DealApi {
  public static getDealData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealDataQuery, payload);
  }

  public static getDealDataByFile(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealDataByFileQuery, payload);
  }

  public static getDealTaskAttachmentTextData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealTaskAttachmentTextDataQuery, payload);
  }

  public static getDealFileTextData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealFileTextDataQuery, payload);
  }

  public static viewDealFile(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(viewDealFileMutation, payload);
  }

  public static saveDealData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealDataMutation, payload);
  }

  public static saveDealStatus(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealStatusMutation, payload);
  }

  public static saveDealTabSettings(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealTabSettingsMutation, payload);
  }
}
